import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../shared/services/auth.service';
import { UserSessionService } from '../../../shared/services/user-session.service';
import { CarehomeAssignment } from '../../../shared/model/user/UserBasicInfo';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
	templateUrl: './no-access.component.html',
	styleUrls: ['./no-access.component.scss']
})
export class NoAccessComponent implements OnInit {
	@ViewChild('logoutForm', { static: true }) logoutForm: ElementRef<HTMLFormElement>;

	frontendHomeUrl = window.location.origin + '/';
	careHomeAssignments: CarehomeAssignment[] = [];
	hasAssignments = false;

	constructor(
		public authService: AuthService,
		private userSessionService: UserSessionService,
		private router: Router,
		private translate: TranslateService
	) { }

	ngOnInit(): void {
		this.loadCareHomeAssignments();

		if (this.careHomeAssignments.length === 1) {
			this.selectCareHome(this.careHomeAssignments[0]);
		}
	}

	loadCareHomeAssignments(): void {
		this.careHomeAssignments = this.userSessionService.getCarehomeAssignments();
		this.hasAssignments = this.careHomeAssignments.length > 0;
	}

	selectCareHome(assignment: CarehomeAssignment): void {
		Swal.fire({
			title: this.translate.instant('common.switching'),
			text: this.translate.instant('common.pleaseWait'),
			allowOutsideClick: false,
			allowEscapeKey: false,
			didOpen: () => {
				Swal.showLoading();
			}
		});

		this.authService.switchCarehome(assignment.CarehomeId).subscribe({
			next: async (response) => {
				const userData = response.body;
				if (userData) {
					this.userSessionService.initializeUserSession(userData);
				}
				const targetRoute = this.userSessionService.getDefaultLandingPageByRole();
				await this.router.navigateByUrl('/', { skipLocationChange: true });
				await this.router.navigate([targetRoute]);
				Swal.close();
			},
			error: (err) => {
				Swal.close();
				Swal.fire({
					icon: 'error',
					title: this.translate.instant('common.error'),
					text: this.translate.instant('common.switchCarehomeFailed')
				});
				console.error('Failed to switch care home', err);
			}
		});
	}

	logout(): void {
		this.userSessionService.clearUserSession();
		this.logoutForm?.nativeElement.submit();
	}
}
